module.exports = __webpack_public_path__ + "static/img/ll03.8ec7cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ll03.png
// module id = 9FKp
// module chunks = 0